export function parseDate(date) {
  if (date) {
    const d = new Date(date);
    return d.toLocaleDateString() + " " + d.toLocaleTimeString();
  }
  return ''
}

export function changeDateISOValue(date, { 
  newYear, 
  newMonth, 
  newDay, 
  newHours, 
  newMinutes, 
  newSeconds, 
  newMilliseconds 
}) {
  const newDate = new Date(date);

  if (newYear) {
    newDate.setFullYear(newYear);
  }

  if (newMonth) {
    newDate.setMonth(newMonth);
  }

  if (newDay) {
    newDate.setDate(newDay);
  }

  if (newHours) {
    newDate.setHours(newHours);
  }

  if (newMinutes) {
    newDate.setMinutes(newMinutes);
  }

  if (newSeconds) {
    newDate.setSeconds(newSeconds);
  }

  if (newMilliseconds) {
    newDate.setMilliseconds(newMilliseconds);
  }

  const year = newDate.getFullYear();
  const month = newDate.getMonth() + 1;
  const day = newDate.getDate();
  const hours = newDate.getHours();
  const minutes = newDate.getMinutes();
  const seconds = newDate.getSeconds();
  const milliseconds = newDate.getMilliseconds();

  const newDateISO = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}.${String(milliseconds).padStart(3, '0')}Z`;

  return newDateISO;
}